import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import ClientWalletTable from './components/ClientWalletTable'

// Breadcrumbs
const crmBreadcrumb: PageLink = {title: 'CRM', path: '/', isSeparator: false, isActive: false}

function ClientWalletPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Client Wallet</PageTitle>
              <ClientWalletTable />
            </>
          }
        />
      </Route>

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default ClientWalletPage
